import React, { useEffect, useState } from 'react';
import {
  UserOutlined,
  MenuUnfoldOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  ProductOutlined,
  GiftOutlined,
  HeartOutlined,
  GatewayOutlined,
  AuditOutlined,
  SettingOutlined,
  TagOutlined,
  GroupOutlined,
  PayCircleOutlined,
  PrinterOutlined,
  HomeOutlined,
  UsergroupAddOutlined,
  HddOutlined,
  BarChartOutlined

} from '@ant-design/icons';
import { Button, Layout, Menu, theme } from 'antd';
import PageRoutes from "./PageRoutes"
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "contexts/auth"

const { Header, Sider, Content } = Layout;

const allMenu = [
  {
    key: '/dashboard',
    icon: <HomeOutlined />,
    label: 'Tổng quan',
    permission: "",
  },
  {
    key: '/orders',
    icon: <FileTextOutlined />,
    label: 'Đơn hàng',
    permission: "order.all",
  },
  {
    key: '/product',
    icon: <ProductOutlined />,
    label: 'Sản phẩm',
    permission: "product.all",
    children: [
      {
        key: '/products',
        icon: <ProductOutlined />,
        label: 'Danh sách',
        path: "acb"
      },
      {
        key: '/product_collection',
        icon: <ProductOutlined />,
        label: 'Bộ sưu tập',

      },
      {
        key: '/product_option',
        icon: <GatewayOutlined />,
        label: 'Thuộc tính',
      },
      {
        key: '/product_tag',
        icon: <TagOutlined />,
        label: 'Thẻ',
      },
      {
        key: '/product_category',
        icon: <GroupOutlined />,
        label: 'Phân loại',
      },
    ]

  },



  // {
  //   key: '/payment-confirm',
  //   icon: <FileTextOutlined />,
  //   label: 'Thanh toán',
  // },
  {
    key: '/customers',
    icon: <HeartOutlined />,
    label: 'Khách hàng',
    permission: "customer.all",
  },

  {
    key: '/debt',
    icon: <AuditOutlined />,
    label: 'Công nợ',
    permission: "debt.all",
  },
  {
    key: '/vouchers',
    icon: <GiftOutlined />,
    label: 'Mã giảm giá',
    permission: "voucher.all",
  },
  {
    key: '/website',
    icon: <ShoppingCartOutlined />,
    label: 'Website',
    permission: "website.all",
    children: [
      {
        key: '/website/report',
        icon: <BarChartOutlined />,
        label: 'Tổng quan',
      },
      {
        key: '/website/setting/general',
        icon: <GatewayOutlined />,

        label: 'Thông tin',
      },
      {
        key: 'website/setting/homepage',
        icon: <HomeOutlined />,
        label: 'Trang chủ',
      },
      {
        key: 'website/setting/payment',
        icon: <PayCircleOutlined />,
        label: 'Cổng thanh toán',
      }
      ,
      {
        key: 'website/setting/order',
        icon: <ShoppingCartOutlined />,
        label: 'Chính sách bán hàng',
      },
      {
        key: 'website/setting/shippingfee',
        icon: <HddOutlined />,
        label: 'Phí ship',
      },
      ,
      {
        key: 'website/setting/print',
        icon: <PrinterOutlined />,
        label: 'In',
      },


    ]

  },
  {
    key: '/setting',
    icon: <SettingOutlined />,
    label: 'Cài đặt',
    permission: "setting.all",
    children: [
      {
        key: '/setting/user',
        label: 'Người dùng',
      },


      {
        key: '/loyalty/setting/point/',
        icon: <WalletOutlined />,
        label: 'Tích điểm',
      },



    ]

  },

  {
    key: '/collaborator',
    icon: <UsergroupAddOutlined />,
    label: 'Cộng tác viên',
    permission: "setting.all",
    children: [
      {
        key: '/collaborator/commission',
        label: 'Hoa hồng',
      },

      {
        key: '/collaborator/users',

        label: 'Cộng tác viên',
      },



    ]

  },




  {
    key: '/account',
    icon: <UserOutlined />,
    label: 'Tài khoản',

    children: [


      {
        key: '/account/shoplist',
        label: 'Shop của tôi',
      },

      {
        key: '/account/invitelist',
        label: 'Lời mời truy cập',
      },






    ]

  },



]

const AppMenu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState([])
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {

    var wp = user.work_space;
    var permissions = wp.permissions ?? [];

    var items = [...allMenu];
    if (!["admin", "owner"].includes(wp.role)) {

      items = items.filter(menu => {
        //ko cần quyền
        if (!menu.permission) {
          return true;
        }
        //lọc menu
        if (permissions.includes(menu.permission)) {
          return true;
        }
        // menu theo role
        console.log("wp", wp)
        if (wp.role == menu.role) {
          return true;
        }
        return false;
      })

    }
    setMenuItems(items);

  }, [user])

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const menuClick = (e) => {

    navigate(e.key);
  }

  return (

    <Menu
      theme="dark"
      mode="inline"
      onClick={menuClick}
      defaultSelectedKeys={['']}
      items={menuItems}
    />

  );
};

export default AppMenu;